import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewChild,
  inject,
} from '@angular/core';
import {
  ModalContainerService,
  ShowModalComponents,
  ShowModalContainer,
} from '../../../services/modal-container.service';
import { PayoutsDetailModalComponent } from '../../payouts/payouts-table/payouts-detail-modal/payouts-detail-modal.component';
import { PayoutsOverviewModalComponent } from '../../payouts/payouts-overview-modal/payouts-overview-modal.component';

@Component({
  selector: 'app-modal-container',
  standalone: true,
  imports: [PayoutsDetailModalComponent, PayoutsOverviewModalComponent],
  templateUrl: './modal-container.component.html',
  styleUrl: './modal-container.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ModalContainerComponent {
  private modalContainerService = inject(ModalContainerService);

  @Input() showModal?: ShowModalContainer;

  // @ViewChild('commissionsEditModal')
  // commissionsEditModal?: CommissionsEditModalComponent;

  // @ViewChild('enrollmentModal') enrollmentModal?: EnrollmentModalComponent;

  @ViewChild('payoutsDetailModal')
  payoutsDetailModal?: PayoutsDetailModalComponent;

  // @ViewChild('policyUpdatesEditModal')
  // policyUpdatesEditModal?: PolicyUpdateEditModalComponent;

  ShowModalComponents = ShowModalComponents;

  fireEvent(eventName: string, data: any) {
    console.log('fireEvent', { eventName, data });
    // this.modalContainerService.currentEvents$?.next({ eventName, data });
    if (this.showModal?.id) {
      this.modalContainerService.subscriptionMap[this.showModal.id]?.next({
        eventName,
        data,
      });
    }
  }

  modalDismissed(component: ShowModalComponents, event: any) {
    console.log('modalDismissed', {
      component,
      event,
      showModal: this.showModal,
    });
    if (this.showModal?.id) {
      this.modalContainerService.close(this.showModal.id);
    }
  }
}
